<template>
  <default-layout :breadcrumbs="breadcrumbs">
    <div class="connect-market-page">
      <owner-connect-header />
      <div class="container">
        <page-loading :show="isLoading" />
        <div class="search--container search--listing-container">
          <ButtonSwitchOwnerConnect />

          <div class="connect-market-layout">
            <div class="left--col">
              <search-content></search-content>
            </div>
            <div class="right--col connect-filter-panel" :class="{ active: isActive }">
              <search-filters></search-filters>
            </div>
          </div>
        </div>
      </div>
    </div>
  </default-layout>
</template>

<script>
import DefaultLayout from '@/layouts/default';
import SearchContent from '@/components/search-listing/content';
import SearchFilters from '@/components/search-listing/filters';
import ButtonSwitchOwnerConnect from '@/components/search-listing/button-switch-owner-connect.vue';

import HelperMixin from '@/mixins/helpers';
import { mapState } from 'vuex';
import PageLoading from '@/components/content-loading/page-loading.vue';
import OwnerConnectHeader from '@/components/search-listing/owner-connect-header.vue';

export default {
  name: 'search-listing',
  mixins: [HelperMixin],
  components: {
    OwnerConnectHeader,
    PageLoading,
    DefaultLayout,
    SearchContent,
    SearchFilters,
    ButtonSwitchOwnerConnect,
  },
  computed: {
    ...mapState({
      isActive: (state) => state.searchListing.activeFilterSidebar,
      listings: (state) => state.searchListing.listings,
      meta: (state) => state.searchListing.meta,
      isLoading: (state) => state.global.isLoading,
      selectedListingType: (state) => state.searchListing.selectedListingType,
      selectedPropertyType: (state) => state.searchListing.selectedPropertyType,
      type: (state) => state.searchListing.type,
    }),
    breadcrumbs() {
      return [
        {
          text: this.$t('breadcrumb.homepage'),
          to: '/',
        },
        {
          text: this.$t('breadcrumb.ownerConnect'),
          to: this.$router.currentRoute.path,
        },
      ];
    },
  },
  async fetch({ store, route, query, error }) {
    console.log(
      'Panggil get search project dari fetch di search/index.vue dengan isi route: ',
      route,
    );

    store.commit('global/SET_LOADING', true);

    store.commit('searchListing/set_listings', { data: [], meta: null });

    let newParams = route.params;

    let allPromises = [];
    const categoryId = parseInt(query.property_category);
    await store.dispatch('searchListing/setSelectedCategoryId', {
      payload: categoryId,
      query: query,
    });

    try {
      await Promise.all(allPromises);
    } catch (e) {
      error(new Error(e.message), 404);
    }

    await store.dispatch('masters/getPropertyTypes');

    allPromises = [];
    allPromises.push(
      store.dispatch('searchListing/getSearchListing', {
        query: query,
        params: newParams,
      }),
    );
    if (store.state.global.loggedIn) {
      allPromises.push(
        store.dispatch('searchListing/getShortlistUuids', {
          listingType: store.getters['searchListing/listingType'],
        }),
      );
    }

    try {
      await Promise.all(allPromises);
    } catch (e) {
      error(new Error(e.message), 404);
    }
    store.commit('global/SET_LOADING', false);
    store.commit('head/RESTORE_DEFAULT_VALUE', route);
  },
  async mounted() {
    await this.mountSearch();
  },
  methods: {
    // Fungsi ini harus tetap dipanggil karena state.global.loggedIn di fetch belum update saat pertama load page.
    async mountSearch() {
      if (this.$store.state.global.loggedIn) {
        await this.$store.dispatch('searchListing/getShortlistUuids', {
          listingType: this.$store.getters['searchListing/listingType'],
        });
      }
    },
  },
};
</script>

<style scoped lang="scss">
@import '@/assets/scss/utils/variables';

.connect-market-page {
  min-height: 100vh;
  padding-bottom: 56px;
  background: #fafafa;
}

.connect-market-panel {
  position: relative;
  padding: 18px;
  border: 1px solid #eeeeee;
  border-radius: 18px;
  background: #ffffff;
  box-shadow: 0 12px 30px rgba(33, 33, 33, 0.05);
  overflow: hidden;

  > * {
    position: relative;
    z-index: 1;
  }
}

.connect-market-layout {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 332px;
  gap: 40px;
  align-items: start;

  .left--col {
    width: 100%;
    min-width: 0;
    margin-right: 0;
  }

  .right--col {
    width: 100%;
  }
}

.connect-filter-panel {
  position: sticky;
  top: 120px;
  border-radius: 16px;
  background: #ffffff;
  overflow: hidden;
  box-shadow: 0 12px 30px rgba(33, 33, 33, 0.05);
}

@media #{$tablets} {
  .connect-market-layout {
    grid-template-columns: minmax(0, 1fr) 286px;
    gap: 16px;
  }

  .connect-filter-panel {
    top: 96px;
    border-radius: 14px;
  }
}

@media #{$phones} {
  .connect-market-layout {
    display: block;
  }

  .connect-filter-panel {
    position: fixed;
    top: 0;
    left: 100%;
    right: auto;
    bottom: auto;
    z-index: 2200;
    width: 100vw;
    height: 100vh;
    display: flex;
    flex-direction: column;
    border-radius: 0;
    box-shadow: -18px 0 36px rgba(0, 0, 0, 0.12);
    overflow-y: auto;
    transition: left 0.28s ease;

    &.active {
      left: 0;
    }
  }

  .connect-market-panel {
    padding: 12px;
    border-radius: 18px;
  }
}
</style>
